import { render } from "./ShopRanking.vue?vue&type=template&id=2d13daea&scoped=true"
import script from "./ShopRanking.vue?vue&type=script&lang=js"
export * from "./ShopRanking.vue?vue&type=script&lang=js"

import "./ShopRanking.vue?vue&type=style&index=0&id=2d13daea&lang=scss&scoped=true"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d13daea"]])

export default __exports__